import React from 'react';
import PropTypes from 'prop-types';
import { find } from 'lodash';

import { InputDropDown } from '@sm360/widget-commons-forms';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { PurchaseMethodsV25, PaymentOptionsMetadata, Quote } from '@sm360/widget-commons-vehicle';
import { AnalyticsService, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';

import 'react-dropdown/style.css';

const { PaymentFrequencies } = PurchaseMethodsV25;

const CustomizePaymentFrequency = ({
    purchaseMethods,
    onPaymentFrequencyClick,
    paymentOptionsMetadata,
    quote,
    config,
}) => {
    const frequencyOptions = purchaseMethods.getSelectedFinanceFrequenciesParameters(
        LocaleService,
        paymentOptionsMetadata
    );
    const selectedFrequency = find(frequencyOptions, {
        value: purchaseMethods.getSelectedFinancePaymentFrequency(),
    });
    const onChange = (paymentFrequency) => {
        onPaymentFrequencyClick(paymentFrequency, config);
        AnalyticsService.ga4Trigger(
            TAGS.PAYMENT_CALCULATOR_FREQUENCY(paymentFrequency.label, quote.vehicle.model.name, quote.vehicle.year)
        );
    };
    return (
        <div className="customize-payment-frequency">
            <InputDropDown
                name="paymentFrequencies"
                options={frequencyOptions}
                value={selectedFrequency ? selectedFrequency.value : PaymentFrequencies.MONTHLY}
                valueChange={onChange}
                classNames={['sr-paymentCalculator-dropdown']}
            />
        </div>
    );
};

CustomizePaymentFrequency.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethodsV25.PurchaseMethodsModelV25).isRequired,
    paymentOptionsMetadata: PropTypes.arrayOf(PropTypes.instanceOf(PaymentOptionsMetadata.PaymentOptionsMetadataModel))
        .isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModelV25).isRequired,
    onPaymentFrequencyClick: PropTypes.func.isRequired,
};

CustomizePaymentFrequency.displayName = 'CustomizePaymentFrequency';

export default CustomizePaymentFrequency;
